(() => {
  const configEl = document.getElementById('ThemeCommerceConfig');
  if (!configEl || !window.TrendifyCommerceRules) return;
  const config = JSON.parse(configEl.textContent);
  const rules = window.TrendifyCommerceRules;
  const root = config.root || '/';
  async function api(query, variables) {
    if (!config.token) throw new Error('Checkout is temporarily unavailable. Please contact us on WhatsApp.');
    const response = await fetch(`https://${config.domain}/api/2026-10/graphql.json`, { method:'POST', headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':config.token}, body:JSON.stringify({query,variables}) });
    if (!response.ok) throw new Error('Unable to open checkout. Please try again.');
    const data = await response.json();
    if (data.errors?.length) throw new Error(data.errors.map(e=>e.message).join(', '));
    return data.data;
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.commerceReady) return;
      section.dataset.commerceReady = 'true';
      const product = JSON.parse(section.querySelector('[data-product-json]').textContent);
      const form = section.querySelector('.product-form');
      const select = section.querySelector('[data-variant-select]');
      const quantity = form.elements.quantity;
      const error = section.querySelector('[data-product-error]');
      const orderButtons = [...section.querySelectorAll('[data-order-now], [data-sticky-order]')];
      let busy = false;
      const money = cents => new Intl.NumberFormat('en-PK',{style:'currency',currency:config.currency || 'PKR'}).format(cents/100);
      function chosen() { return product.variants.find(v=>String(v.id)===select.value); }
      function refresh() {
        const variant = chosen();
        const q = Math.max(1,Math.min(99,Number(quantity.value)||1));
        quantity.value = String(q);
        const bundle = product.handle === rules.flawlessHandle ? rules.bundleTotal(q) : null;
        section.querySelector('[data-product-price]').textContent = bundle === null ? money((variant?.price || 0)*q) : money(bundle*100);
        section.querySelector('[data-availability]').textContent = variant?.available ? 'Available to order' : 'Sold out';
        [...orderButtons,form.querySelector('[name=add]')].forEach(b=>{ b.disabled=busy || !variant?.available; });
        section.querySelectorAll('[name=bundle]').forEach(r=>{r.checked=Number(r.value)===q;});
        if (variant?.featured_image?.src) {
          const image=section.querySelector('#ProductMainImage');
          if(image){ image.src=variant.featured_image.src; image.removeAttribute('srcset'); }
        }
      }
      select.addEventListener('change',refresh);
      quantity.addEventListener('change',refresh);
      section.querySelectorAll('[data-quantity-change]').forEach(b=>b.addEventListener('click',()=>{quantity.value=String(Number(quantity.value)+Number(b.dataset.quantityChange));refresh();}));
      section.querySelectorAll('[name=bundle]').forEach(r=>r.addEventListener('change',()=>{quantity.value=r.value;refresh();}));
      section.querySelectorAll('[data-gallery-image]').forEach(b=>b.addEventListener('click',()=>{const image=section.querySelector('#ProductMainImage');if(image){image.src=b.dataset.galleryImage;image.removeAttribute('srcset');}}));
      async function addToBag() {
        const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:Number(quantity.value)}]})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Could not add this item. Please try again.');
        return data;
      }
      async function purchase(checkout) {
        if(busy || !chosen()?.available) return;
        busy=true;error.hidden=true;refresh();orderButtons.forEach(b=>{b.textContent='Please wait…';});
        try {
          await addToBag();
          const response=await fetch(root+'cart.js');
          if(!response.ok) throw new Error('Could not read your bag. Please try again.');
          const cart=await response.json();
          const count=document.querySelector('[data-cart-count]');if(count) count.textContent=cart.item_count;
          const discountCodes=[...new Set(cart.items.map(item=>rules.discountFor(item.handle,item.quantity)).filter(Boolean))];
          try { sessionStorage.setItem('trendifyone-bundle-discount',discountCodes[0] || ''); } catch {}
          if(!checkout){ window.location.assign(root+'cart');return; }
          const data=await api('mutation CreateCheckout($input: CartInput!) { cartCreate(input:$input) { cart { id checkoutUrl } userErrors { message } } }',{input:{lines:cart.items.map(item=>({merchandiseId:`gid://shopify/ProductVariant/${item.variant_id}`,quantity:item.quantity})),discountCodes,buyerIdentity:{countryCode:'PK'}}});
          if(data.cartCreate.userErrors.length) throw new Error(data.cartCreate.userErrors.map(e=>e.message).join(', '));
          if(!data.cartCreate.cart?.checkoutUrl) throw new Error('Checkout could not be opened. Your items remain in your bag.');
          const url=new URL(rules.checkoutUrl(data.cartCreate.cart.checkoutUrl));
          const params=new URLSearchParams(window.location.search);
          ['fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(k=>{if(params.get(k))url.searchParams.set(k,params.get(k));});
          window.location.assign(url.toString());
        } catch(e) {error.textContent=e.message || 'Something went wrong. Please try again.';error.hidden=false;}
        finally {busy=false;orderButtons.forEach(b=>{b.textContent='ORDER NOW →';});refresh();}
      }
      orderButtons.forEach(b=>b.addEventListener('click',()=>purchase(true)));
      form.addEventListener('submit',e=>{e.preventDefault();purchase(false);});
      refresh();
    });
    const cartForm = scope.querySelector('#CartForm');
    if(cartForm && !cartForm.dataset.commerceReady) {
      cartForm.dataset.commerceReady='true';
      cartForm.addEventListener('submit',async e=>{
        if(e.submitter?.name !== 'checkout') return;
        e.preventDefault();
        const button=e.submitter;
        button.disabled=true;button.textContent='Please wait…';
        let error=cartForm.querySelector('[data-cart-error]');
        if(!error){error=document.createElement('p');error.setAttribute('role','alert');error.dataset.cartError='true';cartForm.append(error);}
        error.textContent='';
        try {
          const updates=[...cartForm.querySelectorAll('[name="updates[]"]')].map(input=>Math.max(0,Number(input.value)||0));
          const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
          if(!response.ok) throw new Error('Could not update your bag. Please try again.');
          const cart=await response.json();
          if(!cart.items.length) {window.location.reload();return;}
          const discountCodes=[...new Set(cart.items.map(item=>rules.discountFor(item.handle,item.quantity)).filter(Boolean))];
          const data=await api('mutation CreateCheckout($input: CartInput!) { cartCreate(input:$input) { cart { id checkoutUrl } userErrors { message } } }',{input:{lines:cart.items.map(item=>({merchandiseId:`gid://shopify/ProductVariant/${item.variant_id}`,quantity:item.quantity})),discountCodes,buyerIdentity:{countryCode:'PK'}}});
          if(data.cartCreate.userErrors.length) throw new Error(data.cartCreate.userErrors.map(e=>e.message).join(', '));
          if(!data.cartCreate.cart?.checkoutUrl) throw new Error('Checkout could not be opened. Please try again.');
          window.location.assign(rules.checkoutUrl(data.cartCreate.cart.checkoutUrl));
        } catch(e) {error.textContent=e.message || 'Could not open checkout. Please try again.';}
        finally {button.disabled=false;button.textContent='Checkout →';}
      });
    }
  }
  initialize();
  document.addEventListener('shopify:section:load', e=>initialize(e.target));
})();
